export enum Keys {
  LEFT = "ArrowLeft",
  RIGHT = "ArrowRight",
  UP = "ArrowUp",
  DOWN = "ArrowDown",
  ESC = "Escape",
  ENTER = "Enter",
}
